import React from 'react';
import { Link } from 'react-router-dom';
const services = [
  {
    label: 'Mutual Fund Returns',
    desc: 'Calculate your interest returns for investment with taxNwealth Online Mutual Funds Returns Calculator.',
    url: '/MutualFundcalculator',
  },
  {
    label: 'SIP Calculator',
    desc: 'Helps you determine the returns you can avail when parking your funds in such investment tools with taxNwealth.',
  },
  {
    label: 'SWP Calculator',
    desc: 'Gives you the total value of your investment at the end of your SWP tenure.',
  },
];

const MutualCalculator = () => {
  return (
    <>
   
    <div className="services-section container py-5">
      <h1 className="text-center fw-bold mb-5">Returns Calculator Tools</h1>
      <div className="row g-4">
        {services.map((service, index) => (
          <div className="col-md-4" key={index}>
            <div className="service-card p-4 h-100 rounded-4 shadow-sm text-start">
             
              <h5 className="fw-bold mb-2">{service.label}</h5>
              <p className="text-muted">{service.desc}</p>
              <Link to={service.url} className="fw-bold text-primary text-decoration-none">
              Calculate now <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default MutualCalculator;
